import { Text } from '@beef/ui-kit';
import React from 'react';
import classNames from 'classnames/bind';
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var Description = function Description(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('component')
  }, /*#__PURE__*/React.createElement(Text, {
    className: "marb-xs",
    size: "size5-m"
  }, title), children);
};